module.exports = __webpack_public_path__ + "static/media/seo-1.70a3be28.jpg";